import { useRequest } from './useRequest';
import { RegisterCredentials, LoginResponse } from '../types/auth';
import { useState } from 'react';
import { useUserValidations } from './useUserValidations';

export function useRegister() {
  const registerRequest = useRequest<LoginResponse>();
  const [emailExists, setEmailExists] = useState(false);
  const [cpfCnpjExists, setCpfCnpjExists] = useState(false);
  const { checkEmailExists: checkEmailUniqueness, checkCpfCnpjExists: checkCpfCnpjUniqueness } = useUserValidations();

  // Função para verificar se email já existe (compatibilidade com interface existente)
  const checkEmailExists = async (email: string): Promise<boolean> => {
    const exists = await checkEmailUniqueness(email);
    setEmailExists(exists);
    return exists;
  };

  // Função para verificar se CPF/CNPJ já existe (compatibilidade com interface existente)
  const checkCpfCnpjExists = async (cpfCnpj: string): Promise<boolean> => {
    const exists = await checkCpfCnpjUniqueness(cpfCnpj);
    setCpfCnpjExists(exists);
    return exists;
  };

  // Função para registrar usuário
  const register = async (credentials: RegisterCredentials) => {
    // Verificar existência antes de registrar
    const emailTaken = await checkEmailExists(credentials.email);
    const cpfCnpjTaken = await checkCpfCnpjExists(credentials.cpfCnpj);

    if (emailTaken || cpfCnpjTaken) {
      return; // Não prosseguir se já existir
    }

    registerRequest.execute(`${process.env.REACT_APP_API_BASE_URL}/api/autenticador/registrar`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
  };

  return {
    register,
    checkEmailExists,
    checkCpfCnpjExists,
    emailExists,
    cpfCnpjExists,
    data: registerRequest.data,
    loading: registerRequest.loading,
    error: registerRequest.error,
  };
}